import script from "./OnboardComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardComponent.vue?vue&type=script&setup=true&lang=js"

import "./OnboardComponent.vue?vue&type=style&index=0&id=e1b72d80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1b72d80"]])

export default __exports__